type fireExtoleSignUpType = {
  email: string;
  first_name: string;
  last_name: string;
};

export function fireExtoleSignUp({
  email,
  first_name,
  last_name,
}: fireExtoleSignUpType) {
  if (typeof window !== "undefined" && typeof window?.extole === "object") {
    window.extole.createZone({
      name: "registration",
      data: {
        email: email,
        first_name,
        last_name,
      },
    });
  }
}
